import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { Allocation } from "@hubcapp/types";

import updateHourlyRate from "../graph-ql/updateHourlyRate.graphql";

const useMutationUpdateHourlyRate = ({ onCompleted }: MutationHookOptions) =>
  useMutation<
    { allocation: Allocation },
    { allocationId: string; rate: number }
  >(updateHourlyRate, {
    onCompleted,
  });

export default useMutationUpdateHourlyRate;
